// Lot C (18/09/2026) — Decision de garde de l'icebreaker, extraite d'App.js
// pour etre testee isolement (le « cablage, pas l'apparence »).
//
// Regle produit FIGEE :
//  - Entree en formation (/formation) : autorisee UNIQUEMENT si l'icebreaker
//    est termine. Toute autre valeur de isDone (false, null, undefined) bloque
//    et redirige vers /icebreaker. On echoue FERME : l'icebreaker reste
//    obligatoire AVANT une formation, sans dependre du contrat back pour la
//    normalisation du booleen.
//  - Icebreaker termine (isDone === true) : /icebreaker renvoie au dashboard
//    (plus rien a y faire).
//  - Sinon : aucune redirection. Le dashboard et les autres pages restent
//    accessibles meme si l'icebreaker n'est pas termine (il n'enferme plus).
//
// C'est une decision d'AIGUILLAGE : elle ne modifie jamais isDone
// (quitter != terminer).
//
// Retourne la cible de redirection ("/icebreaker" | "/dashboard") ou null.
export function redirectionIcebreaker(isDone, pathname) {
  if (pathname === "/formation" && isDone !== true) {
    return "/icebreaker"
  }
  if (pathname === "/icebreaker" && isDone === true) {
    return "/dashboard"
  }
  return null
}
